exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-checkbox-group{font-size:14px}.el-checkbox__label{white-space:normal}", ""]);

// exports
